import { PageShare } from './PageShare';

export default PageShare;
